import { KeyboardEvent } from 'react';

/**
 * Handle the escape key event.
 *
 * @param {KeyboardEvent} event
 * @param {Function} action
 */
export const handleEscapeKey = (
  event: KeyboardEvent,
  action?: () => void,
  preventDefault = true,
) => {
  if (event.key === 'Escape') {
    if (preventDefault) {
      event.preventDefault?.();
      event.stopPropagation?.();
    }
    action?.();
  }
};
